var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.193359,
    y: 0.789551,
    width: 43,
    height: 43,
    rx: 10,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.885 22.4158C27.8741 20.6125 28.714 19.2534 30.4102 18.2513C29.4615 16.9292 28.0263 16.2021 26.1345 16.0619C24.3432 15.9244 22.3834 17.0773 21.6658 17.0773C20.9074 17.0773 19.1732 16.1095 17.8087 16.1095C14.9927 16.1518 12 18.2936 12 22.6511C12 23.9388 12.2419 25.2688 12.7258 26.6385C13.3727 28.4417 15.7049 32.8601 18.1376 32.7887C19.4097 32.7596 20.3094 31.9108 21.9648 31.9108C23.5712 31.9108 24.403 32.7887 25.8219 32.7887C28.2764 32.7543 30.3857 28.7379 31 26.9293C27.7083 25.4195 27.885 22.5083 27.885 22.4158ZM25.0282 14.3512C26.4063 12.7594 26.2813 11.3104 26.2405 10.7896C25.0227 10.8583 23.6147 11.596 22.8129 12.5029C21.9295 13.476 21.4103 14.6791 21.5217 16.0355C22.8373 16.1333 24.0388 15.4749 25.0282 14.3512Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple_store.50c251398b77ce4de90bd1f492ddf27e.svg";
export { ForwardRef as ReactComponent };